module.exports = __webpack_public_path__ + "img/stats.c5120d9f.svg";